const isProduction = process.env.NODE_ENV === 'production'

document.addEventListener('DOMContentLoaded', () => {
  import('focus-visible').then((module) => module)
  import('utility/prefetch').then((module) => module.default.init())
  import('components/scrollers').then((module) => module.default.init())
  import('components/custom-fav').then((module) => module.default.init())
  import('utility/hyphen').then((module) => module.default.init())

  // RMOVE THIS WHEN YOU START THE PROJECT
  // if (document.querySelectorAll<HTMLElement>('.body')) {
  //   import('components/tester').then((module) => module.default.init())
  // }

  if (document.querySelectorAll<HTMLElement>('.modal')) {
    import('components/modal').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.tabs')) {
    import('components/tabs').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.chatbubble')) {
    import('components/chat-bubble').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.employee-list')) {
    import('components/employee-filter').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.courses-summary')) {
    import('components/course-summary-filter').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.mobile-header')) {
    import('components/mobile-nav').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.attendance-list')) {
    import('components/attendance').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.attendance-form')) {
    import('components/attendance-validate').then((module) => module.default.init())
  }

  if (document.querySelectorAll<HTMLElement>('.key-step')) {
    import('components/keysteps').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('#searchform')) {
    import('components/search-url').then((module) => module.default.init())
  }
  if (document.querySelectorAll<HTMLElement>('.announcements')) {
    import('components/announcements').then((module) => module.default.init())
  }

  // Accessibility for checkbox hack (pretty-check)
  if (document.querySelector<HTMLElement>('.pretty-check')) {
    import('components/pretty-check').then((module) => module.default.init())
  }
  if (document.querySelector<HTMLElement>('.pretty-check')) {
    import('components/pretty-check').then((module) => module.default.init())
  }

  if (!isProduction) {
    if (document.querySelector<HTMLElement>('.overlay-grid')) {
      import('helpers/overlay-grid').then((module) => module.default.init())
    }
  }

  setTimeout(() => {
    document.querySelector('.body').classList.add('loaded')
  }, 100)
  setTimeout(() => {
    document.querySelector('.body').classList.add('preload--hidden')
    document.querySelector('.body').classList.remove('preload--transitions')
  }, 400)
})
